import type { Lookups } from "../../types";
import type { FilterModule } from "../index";
import { IndustryFilter } from "./IndustryFilter";
import { getChips, getCount } from "./chips";
import { fromCompanyFilters, toCompanyFilters } from "./mapper";
import { defaultIndustrySlice, type IndustrySlice } from "./slice";

export type { IndustrySlice } from "./slice";
export { defaultIndustrySlice } from "./slice";

export const industryModule: FilterModule<IndustrySlice, Lookups> = {
  key: "industry",
  defaultSlice: defaultIndustrySlice,
  Component: IndustryFilter,
  getChips,
  getCount,
  toCompanyFilters,
  fromCompanyFilters,
};
